export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-200/50 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
          <div className="col-span-2 sm:col-span-1">
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="inline-flex items-center gap-2 font-heading text-lg font-bold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <span className="w-7 h-7 flex items-center justify-center bg-primary-500 text-background-50 rounded-md text-xs font-bold">91</span>
              91免费
            </a>
            <p className="mt-3 text-xs text-foreground-500 leading-relaxed">
              91免费是国内领先的免费看片软件下载平台，提供91免费看片app最新版本下载，覆盖Android、iOS、Windows、Mac全平台。看片app免费安装，即刻获取91免费客户端的app。
            </p>
          </div>

          <div>
            <div className="text-sm font-semibold text-foreground-900 mb-3">快速导航</div>
            <div className="flex flex-col gap-2">
              <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">首页</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">热门榜单</a>
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">推荐应用</a>
              <a href="#features" onClick={(e) => handleNavClick(e, '#features')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">平台优势</a>
              <a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">最新动态</a>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold text-foreground-900 mb-3">内容板块</div>
            <div className="flex flex-col gap-2">
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">专题索引</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">常见问答</a>
              <a href="#media" onClick={(e) => handleNavClick(e, '#media')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">精选视频</a>
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">话题标签</a>
              <a href="#carousel" onClick={(e) => handleNavClick(e, '#carousel')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">焦点专题</a>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold text-foreground-900 mb-3">关于我们</div>
            <div className="flex flex-col gap-2">
              <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">平台介绍</a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">联系我们</a>
              <a href="#app" onClick={(e) => handleNavClick(e, '#app')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">客户端下载</a>
              <a href="#comments" onClick={(e) => handleNavClick(e, '#comments')} className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">读者评论</a>
            </div>
          </div>

          <div>
            <div className="text-sm font-semibold text-foreground-900 mb-3">合作伙伴</div>
            <div className="text-xs text-foreground-400 leading-relaxed">
              我们正在寻找优质的合作伙伴，共同打造更好的免费看片软件生态。如有合作意向，欢迎通过联系我们页面与我们取得联系。
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/60">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2026 91免费. 本站所有91免费看片软件均提供免费下载，请从本站官方渠道下载以确保安全。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span className="cursor-pointer hover:text-primary-600 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-600 transition-colors">使用条款</span>
            <span className="cursor-pointer hover:text-primary-600 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}